<template>
  <sky-suffix
    v-bind="$attrs"
    @search-click="search"
  >
    <el-input
      type="textarea"
      v-bind="$attrs"
      :value="value"
      v-focus="focus"
      @input="handleChange"
    ></el-input>
    <slot
      name="toolTips"
      slot="toolTips"
    ></slot>
  </sky-suffix>
</template>
<script>
import SkySuffix from '../formComponents/SkySuffix.vue'
export default {
  name: 'sky-textarea',
  componentName: 'sky-textarea',
  components: {
    SkySuffix
  },
  props: ['value', 'focus'],
  created() {},
  data() {
    return {}
  },
  methods: {
    search(e) {
      this.$emit('search-click', e)
    },
    handleChange(e) {
      this.$emit('input', e)
    }
  },
  directives: {
    focus: {
      update(el, data) {
        // 重点注意这里 当前元素是div  所以要查到子元素中的input
        const dom = el.querySelector('input') || el.querySelector('textarea')
        if (data.value) dom.focus()
      }
    }
  }
}
</script>
